var canvasMap = {};
var defaultCanvasIdCounter = 0;
/**
 * destroy existed canvas with the same id
 */

export function cleanExistedCanvas(container, canvas) {
  if (container) {
    var id = typeof container === 'string' ? container : container.id || defaultCanvasIdCounter++;

    if (canvasMap[id]) {
      canvasMap[id].destroy();
    }

    canvasMap[id] = canvas;
  }
}
export var isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined';